import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { selectSelectedOffer } from 'redux/modules/offer';
import { decorateWith, withName } from 'helpers/decorator';
import { isEmpty } from 'helpers/verify';
import { CmsText } from 'components/CmsPage/modules/CmsText/CmsText';
import { updateSelectedOffer } from '../sagas/product.saga';

export class MultiOffersUnwrapped extends Component {
  componentDidMount() {
    const { checkFirstOfferByDefault } = this.props;
    let { selectedOffer } = this.props;
    if (checkFirstOfferByDefault && isEmpty(selectedOffer)) {
      [selectedOffer] = this.props.offers;
      this.props.updateSelectedOffer(selectedOffer);
    }
  }

  handleOfferClick(offer) {
    this.props.updateSelectedOffer(offer);
  }

  render() {
    const { cmsModuleId, offers, selectedOffer } = this.props;

    return (
      <div className="MultiOffers__content">
        {offers.map((offer, idx) => {
          return (
            <div className="MultiOffers__offer">
              <label
                className="MultiOffers__offer__label"
                key={offer.productId}
                htmlFor={`MultiOffers__offer-${offer.productId}`}>
                <input
                  id={`MultiOffers__offer-${offer.productId}`}
                  type="radio"
                  name="MultiOffers__offer-value"
                  onChange={this.handleOfferClick.bind(this, offer)}
                  checked={selectedOffer.productId === offer.productId}
                />
                <span>
                  {!isEmpty(offer.coMembershipInfo) && (
                    <CmsText
                      className="MultiOffers__coMembership-banner"
                      cmsModuleId={`ProductCard:CoMembershipBanner:${cmsModuleId}:Offer:${offer.productId}`}
                      content={offer.coMembershipInfo.banner}
                      size="tiny"
                    />
                  )}
                  <CmsText
                    className="MultiOffers__callout"
                    cmsModuleId={`ProductCard:Callout:${cmsModuleId}:Offer:${offer.productId}`}
                    content={offer.callout}
                    size="large"
                  />
                  <CmsText
                    className="MultiOffers__callout-unit"
                    cmsModuleId={`ProductCard:Note:${cmsModuleId}:Offer:${offer.productId}`}
                    content={offer.calloutNote}
                    shouldIgnoreCache
                    size="regular"
                  />
                  <CmsText
                    className="MultiOffers__details"
                    cmsModuleId={`ProductCard:Details:${cmsModuleId}:Offer:${offer.productId}`}
                    content={offer.details}
                    size="medium"
                  />
                  {!isEmpty(offer.coMembershipInfo) && (
                    <CmsText
                      className="MultiOffers__coMembership-details mt-smallPlus"
                      cmsModuleId={`ProductCard:CoMembershipDetails:${cmsModuleId}:Offer:${offer.productId}`}
                      content={offer.coMembershipInfo.details}
                      size="medium"
                    />
                  )}
                </span>
              </label>
              {idx !== offers.length - 1 && <hr />}
            </div>
          );
        })}
      </div>
    );
  }
}

MultiOffersUnwrapped.propTypes = {
  checkFirstOfferByDefault: PropTypes.bool,
  cmsModuleId: PropTypes.string.isRequired,
  offers: PropTypes.array,
  selectedOffer: PropTypes.object,
  updateSelectedOffer: PropTypes.func.isRequired,
};

export const mapStateToProps = state => {
  return {
    selectedOffer: selectSelectedOffer(state),
  };
};

export const mapDispatchToProps = {
  updateSelectedOffer,
};

export const MultiOffers = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('MultiOffers')
)(MultiOffersUnwrapped);
